/**
 * Full-viewport feedback while logout is in progress.
 * Shown whenever AuthContext.isLoggingOut is true (any logout entry point).
 */

import { createPortal } from 'react-dom';

import { useAuth } from '@contexts/AuthContext';

import './SigningOutOverlay.css';

export function SigningOutOverlay() {
  const { isLoggingOut } = useAuth();

  if (!isLoggingOut) {
    return null;
  }

  return createPortal(
    <div
      className="bhg-signing-out-overlay"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="bhg-signing-out-title"
      aria-busy="true"
    >
      <div className="bhg-signing-out-overlay__card">
        <span className="bhg-signing-out-overlay__spinner" aria-hidden />
        <p id="bhg-signing-out-title" className="bhg-signing-out-overlay__title">
          Signing out…
        </p>
        <p className="bhg-signing-out-overlay__hint">Please wait a moment.</p>
      </div>
    </div>,
    document.body
  );
}

